import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Label } from 'reactstrap';
import { splitByThousands } from '../../helpers/helper';

export const CancelPrice = ({ cancelFee, cancelRate, cancelPrice }) => {
  return (
    <>
      <Label className="mt-3 font-weight-bold">キャンセル料</Label>
      <div className="price">
        <Row>
          <Col sm={5} xs={3}>内訳</Col>
          <Col sm={7} xs={9}>
            <Row>
              <Col>
                キャンセル料(
                {cancelRate}
                %)
              </Col>
              <Col className="text-right">
                {splitByThousands(cancelFee)}
                円
              </Col>
            </Row>
          </Col>
        </Row>
        <hr />
        <p className="pre-tax text-right">
          税別
          {splitByThousands(cancelFee)}
          円
        </p>
        <Row>
          <Col className="total">合計金額</Col>
          <Col className="total-price text-right">
            税込
            <span>
              {splitByThousands(cancelPrice)}
            </span>
            円
          </Col>
        </Row>
      </div>
    </>
  );
};

CancelPrice.propTypes = {
  cancelFee: PropTypes.number.isRequired,
  cancelRate: PropTypes.number.isRequired,
  cancelPrice: PropTypes.number.isRequired,
};
